import { PDF_CATEGORY, PdfType } from 'b2b-common/core/account/api/Pdf.types';
import { CLEAR_ACCOUNT_PDFS, FETCH_PDF, FETCH_PDF_FULFILLED, FETCH_PDF_REJECTED, REMOVE_PDF } from './actionTypes';
import {
  ClearAccountPdfsAction,
  FetchPdfAction,
  FetchPdfFulfilledAction,
  FetchPdfRejectedAction,
  RemovePdfAction,
} from './types';

const fetchPdf = (id: string, category: PDF_CATEGORY): FetchPdfAction => ({
  type: FETCH_PDF,
  payload: {
    category,
    id,
  },
});

const fetchPdfFulfilled = (id: string, category: PDF_CATEGORY, response: PdfType): FetchPdfFulfilledAction => ({
  type: FETCH_PDF_FULFILLED,
  payload: {
    category,
    id,
    data: response,
  },
});

const fetchPdfRejected = (id: string, error: ErrorType): FetchPdfRejectedAction => ({
  type: FETCH_PDF_REJECTED,
  payload: {
    id,
    error,
  },
});

const removePdf = (id: string): RemovePdfAction => ({
  type: REMOVE_PDF,
  payload: {
    id,
  },
});

const clearAccountPdfs = (): ClearAccountPdfsAction => ({
  type: CLEAR_ACCOUNT_PDFS,
});

export {
  clearAccountPdfs,
  fetchPdf,
  fetchPdfFulfilled,
  fetchPdfRejected,
  removePdf,
};
